<div class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 md:tw-bottom-5 md:tw-left-5 md:tw-right-auto md:tw-max-w-[560px] tw-z-50">
  <div class="tw-relative tw-bg-neutral-0 tw-border tw-border-solid tw-border-neutral-100 tw-shadow-input tw-p-6 tw-pt-8 md:tw-pt-6 tw-rounded-t-[20px] md:tw-rounded-lg"
       role="region"
       aria-label="Cookie consent"
       i18n-aria-label="@@core.consent.banner.region.aria">
    <button
      type="button"
      class="tw-absolute tw-top-3 tw-right-3 tw-w-8 tw-h-8 tw-inline-flex tw-items-center tw-justify-center tw-rounded-control tw-border-0 tw-bg-transparent tw-text-neutral-400 hover:tw-bg-neutral-50 hover:tw-text-main-primaryText tw-cursor-pointer"
      aria-label="Dismiss — keeps analytics off"
      i18n-aria-label="@@core.consent.dismiss.aria"
      (click)="dismiss()">
      <mat-icon svgIcon="close" class="icon-size-20"></mat-icon>
    </button>
    <app-consent-panel mechanism="banner"></app-consent-panel>
  </div>
</div>
